import Vue from "vue";
import Vuex from "vuex";

import ItineraryModal from "@/stories/Components/CruiseItineraryDetail/store/modules/ItineraryModal";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ItineraryModal,
  },
});
